import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
// import {appConstants} from "../../_constants";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/FindReplace";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
      paddingLeft: '15px'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 1
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
      marginTop: "0px",
      width: '95%'
  },
    Grid: {
    flexBasis: "14px"
    }
});

function SearchComponent(props) {
  // let { classes, airlines, selectChange, AirlineId, FlightNumber, StartDate, EndDate, flightNumbers } = props;
  let {
    classes,
      airlines, statuses,
      selectChange,
      onSearch,
      handleAddRouteModal,
      createdByStatuses
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
                options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                handleSelectChange={(e, name) => selectChange(e, name)}
                selectLabel={"Airlines"}
                name={"AirlineId"}
            />
            {/*
            <Select
              value={AirlineId}
              onChange={selectChange}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="AirlineId"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airlines</MenuItem>
              {airlines.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.AirlineId}
                  className={classes.select}
                >
                  {option.Airline}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Status
            </InputLabel>
            <AutocompleteSelect
                options={statuses.map((option, i) => ({ value: option.Id, label: option.Name }))}
                handleSelectChange={(e, name) => selectChange(e, name)}
                name={"Status"}
            />
            {/*
            <Select
              value={Status}
              onChange={selectChange}
              input={<Input name="status" id="airline-label-placeholder" />}
              // displayEmpty
              name="Status"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All</MenuItem>
              {statuses.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.Id}
                  className={classes.select}
                >
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Created By
            </InputLabel>
            <AutocompleteSelect
                options={createdByStatuses.map(option => ({ value: option.Id, label: option.Name }))}
                handleSelectChange={(e, name) => selectChange(e, name)}
                name={"createdByStatus"}
            />
            {/*
            <Select
              value={createdByStatus}
              onChange={selectChange}
              input={<Input name="status" id="airline-label-placeholder" />}
              name="createdByStatus"
              className={classes.selectEmpty}
            >
              {createdByStatuses.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.Id}
                  className={classes.select}
                >
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item md={4}>
          <div style={{ float: 'left'}}>
              <Button color={'primary'} onClick={() => onSearch()}>
                  <SearchIcon/> Search
              </Button>
          </div>
          <div style={{ float: 'right'}}>
              <Button color={'danger'} onClick={handleAddRouteModal}>
                  <AddIcon/> Add Route
              </Button>
          </div>

        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/SearchPanel.jsx